<template>
  <v-main id="dashboard-view">
    <div class="view-content">
      <!-- Banner de modo visualização (TENANT_ADMIN visualizando gestor) -->
      <view-only-banner />
      
      <router-view />
    </div>

    <dashboard-core-footer />
  </v-main>
</template>

<script>
  export default {
    name: 'DashboardCoreView',

    components: {
      DashboardCoreFooter: () => import('./Footer'),
      ViewOnlyBanner: () => import('@/components/ViewOnlyBanner'),
    },
  }
</script>

<style lang="sass">
  #dashboard-view
    &.theme--dark
      background-color: #0D0D0D !important

    .v-main__wrap
      min-height: calc(100vh - 64px)
      display: flex
      flex-direction: column
      background-color: inherit
      
    .view-content
      flex: 1
      background-color: inherit

  .theme--dark #dashboard-view .v-main__wrap,
  .theme--dark #dashboard-view .view-content
    background-color: #0D0D0D !important
</style>
